import React from 'react';
import { useLang } from '../i18n/LangContext';
import { CONTACT } from '../data/content';
import { Phone, MessageCircle } from 'lucide-react';

export default function MobileContactBar() {
  const { t } = useLang();
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 gap-0 bg-white border-t border-[#EAE4DA] shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
      <a
        href={`https://wa.me/${CONTACT.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 py-4 bg-[#25D366] text-white font-medium"
      >
        <MessageCircle size={18} /> WhatsApp
      </a>
      <a
        href={`tel:${CONTACT.phoneRaw}`}
        className="flex items-center justify-center gap-2 py-4 bg-[#2C2A26] text-white font-medium"
      >
        <Phone size={18} /> {t.contact.call}
      </a>
    </div>
  );
}
